import commonEnvironment from 'config/de/common-environment';
import paypal from 'config/paypal';
import { ShopEnvironment } from 'config/types';

export default {
  ...commonEnvironment,
  apiEndpoint: 'https://api-staging.petsdeli.de',
  backInStockUrl: 'https://petsdeli-staging.myshopify.com',
  contentfulEnv: 'staging',
  foodaidEndpoint: 'https://api.petsdeli.de/fube-staging-2023-04',
  ninetailedEnv: 'development',
  oosEndpoint: 'https://api-staging.oos.petsdeli.de',
  paypalClientId: paypal.staging,
  pdexEndpoint: 'https://qa.851725625427.petsdeli.de',
  shopifyUrl: 'https://petsdeli-staging.myshopify.com',
  midaKey: 'nvmGW7eJdkWL9dw81xXQKA',
  gtmScriptUrl:
    'https://metrics.petsdeli.de/gtm.js?id=GTM-NK69QT6&gtm_auth=mVziPUTr8RQqgHd0gjcs7Q&gtm_preview=env-334&gtm_cookies_win=x',
  gtmNoScriptUrl:
    'https://metrics.petsdeli.de/gtm.html?id=GTM-NK69QT6&gtm_auth=mVziPUTr8RQqgHd0gjcs7Q&gtm_preview=env-334&gtm_cookies_win=x',
} satisfies ShopEnvironment;
